import { useRespondToRange } from "@animech/ui";
import { FunctionComponent } from "react";
import * as Styled from "./overlay-panel.style";
import { useUiData, Logo } from "src/ui";

export const OverlayPanel: FunctionComponent = () => {
	const { view, logo, renderUiSlot } = useUiData();

	const isTabletDown = useRespondToRange("tablet", "down");

	if (view !== "productPicker") {
		return null;
	}

	const viewProps: Styled.ViewProps = {
		"data-logo-desktop": !!logo.overlay.desktop || undefined,
		"data-logo-mobile": !!logo.overlay.mobile || undefined,
	};

	return (
		<Styled.Root>
			{logo.overlay.desktop && !isTabletDown && (
				<Logo src={logo.overlay.desktop} />
			)}
			{logo.overlay.mobile && isTabletDown && (
				<Logo src={logo.overlay.mobile} />
			)}
			<Styled.View {...viewProps}>
				<Styled.ProductPicker>
					{renderUiSlot("productPicker")}
				</Styled.ProductPicker>
			</Styled.View>
		</Styled.Root>
	);
};
